import React from 'react';
import {
  IconButton,
} from 'material-ui';
import Info from 'material-ui/svg-icons/action/info';

const styles = {
  root: {
    position: 'relative',
    padding: '12px 0',
  },
  icon: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 10,
  },
};

class InfoBadge extends React.Component {
  onClick = (ev) => ev.stopPropagation();
  render() {
    const {
      children, tooltip,
    } = this.props;
    return (
      <div style={styles.root}>
        {children}
        <IconButton
          style={styles.icon}
          onClick={this.onClick}
          tooltip={tooltip}
          touch
        >
          <Info />
        </IconButton>
      </div>
    );
  }
}

export default InfoBadge;
